import React from 'react';
import { connect } from 'react-redux';
import {Button,Paper,Divider,CssBaseline,TextField,Link,Grid,Box,Typography,Container
,FormControl,InputLabel,Select,FormHelperText,Hidden} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { withStyles } from "@material-ui/core/styles";
import { Helmet } from "react-helmet";
import withWidth, { isWidthUp } from '@material-ui/core/withWidth';
import AppointmentHistory from './AppointmentHistory';
import BookAppointment from './BookAppointment';



const useStyles = (theme) => ({
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  typography: {
    margin: theme.spacing(3),
  },divider:{
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3)
  },buttons: {
    display: 'flex',
    justifyContent: 'center',
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
  },
});

class PatientBasicInfo extends React.Component {
    
  constructor(props) {
      super(props);
      this.state = {
          userid : this.props.userid,
          showAddNewAppointmentButton : true,     
          showHistory : true,
          showNewAppointment : false,
          patientId : this.props.patientId     
      };
  }
  
  handleBookAppointmentButton(id){
    this.setState({showNewAppointment:true});
    this.setState({showAddNewAppointmentButton:false});
    this.setState({showHistory:false});
  }

  handleBookNewAppointSuccess(){
    this.setState({showNewAppointment:false});
    this.setState({showAddNewAppointmentButton:true});
    this.setState({showHistory:true});
  }
  
  render(){
    const classes = this.props.classes;
    const { registering  } = this.props;
    const { user, submitted } = this.state;
    return (
      <>
        
        {this.state.showAddNewAppointmentButton ? (
            <Box style={{ display: "flex", justifyContent: "flex-end" }}>
              <Button
                variant="button"
                variant="outlined"
                color="primary"
                onClick={() => {
                  this.handleBookAppointmentButton();
                }}
              >
                Book Appointment
              </Button>
            </Box>
          ) : null} 
        
        {this.state.showHistory?<AppointmentHistory
                  showAddNewAppointment={false}
                  isCalenderView={false}
                  patientId={this.props.patientId}
                  showSingleGrid = {true}
                  showEditAppointment={true}
                />:null}

        {this.state.showNewAppointment?
          <BookAppointment 
          
          handleBookNewAppointSuccess = {()=>{this.handleBookNewAppointSuccess()}} 
            
         patientId={this.state.patientId} /> : null}

        
      </>
    );
  }
}


export default (withStyles(useStyles,{ withTheme: true })(PatientBasicInfo));